import { FC, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
  Button,
  useToast,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import TextInput from "./TextInput";
import { changePasswordValidation } from "utils/validationSchema";
import { updatePassword } from "firebase/auth";
import { auth } from "connections/firebase";
import { getErrorMessage } from "utils";
import { useChangePasswordModal } from "states/changePasswordModal";

interface IChangePasswordFormPayload {
  password: string;
  passwordConfirmation: string;
}

const ChangePassword: FC = () => {
  const [isLoading, setLoading] = useState(false);
  const { isOpen, onClose } = useChangePasswordModal();
  const toast = useToast();

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Ubah Password</ModalHeader>
        <ModalCloseButton />
        <Formik<IChangePasswordFormPayload>
          onSubmit={async (values) => {
            try {
              if (auth.currentUser) {
                setLoading(true);
                await updatePassword(auth.currentUser, values.password);
                toast({
                  title: "Success",
                  description: "Update password berhasil!",
                  status: "success",
                  isClosable: true,
                });
                onClose();
              }
            } catch (error) {
              toast({
                title: "Error",
                description: getErrorMessage(error),
                status: "error",
                isClosable: true,
              });
            } finally {
              setLoading(false);
            }
          }}
          initialValues={{
            password: "",
            passwordConfirmation: "",
          }}
          enableReinitialize
          validationSchema={changePasswordValidation}
        >
          <Form>
            <ModalBody>
              <Stack spacing={2}>
                <TextInput
                  type="password"
                  name="password"
                  id="password"
                  label="Password"
                />
                <TextInput
                  type="password"
                  name="passwordConfirmation"
                  id="passwordConfirmation"
                  label="Konfirmasi Password"
                />
              </Stack>
            </ModalBody>
            <ModalFooter>
              <Button type="reset" colorScheme="red" mr={3} onClick={onClose}>
                Cancel
              </Button>
              <Button isLoading={isLoading} type="submit" colorScheme="blue">
                Submit
              </Button>
            </ModalFooter>
          </Form>
        </Formik>
      </ModalContent>
    </Modal>
  );
};

export default ChangePassword;
